import React, { Component } from "react";

import Intro from "../component/home-desktop/Intro";
import GetToKnowMe from "../component/home-desktop/GetToKnowMe";
import RecentProjects from "../component/home-desktop/RecentProjects";
import LatestBlog from "../component/home-desktop/latestBlog";
import ScrollButton from "../component/home-desktop/ScrollUp";
import {
  getFirestore,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import Footer from "../component/Footer";
// *--------------*
// mobile view
// *--------------*
import IntroMobile from "../mobileview/pages/IntroMobile";

class Home extends Component {
  constructor(props) {
    super(props);
    // Initialize the state
    this.state = {
      windowSize: window.innerWidth,
      latestProject: null,
      totalProject: 0,
    };
  }

  // This function will update windowSize in the state whenever the window is resized
  updateWindowSize = () => {
    this.setState({
      windowSize: window.innerWidth,
    });
  };

  // Add event listener when the component mounts
  componentDidMount() {
    window.addEventListener("resize", this.updateWindowSize);
    // Set initial state based on the current window size
    this.updateWindowSize();
    this.fetchLatestProject(); //fetches the most latest project based on time-frame
  }

  // Remove event listener when the component unmounts to avoid memory leaks
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowSize);
  }

  isCacheExpired = (timestamp) => {
    const now = new Date();
    const cacheTime = new Date(timestamp);
    const diffInDays = (now - cacheTime) / (1000 * 60 * 60 * 24);
    return diffInDays > 30;
  };

  // fetches latest project from database or cache
  fetchLatestProject = async () => {
    // const cacheKey = "latest_project_cache";
    // const timestampKey = "latest_project_cache_time";
    // const cachedData = localStorage.getItem(cacheKey);
    // const cachedTime = localStorage.getItem(timestampKey);

    // if (cachedData && cachedTime && !this.isCacheExpired(cachedTime)) {
    //   const parsed = JSON.parse(cachedData);
    //   this.setState({
    //     latestProject: parsed.latest,
    //     totalProject: parsed.total,
    //   });
    //   return;
    // }

    try {
      const db = getFirestore();
      const q = query(
        collection(db, "projects"),
        where("status", "==", "published")
      );
      const querySnapshot = await getDocs(q);

      const projects = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      if (projects.length > 0) {
        // Convert MMYYYY to YYYYMM for proper chronological comparison
        const convertToSortable = (dateStr) => {
          if (!dateStr || dateStr.length !== 6) return "000000";
          const month = dateStr.slice(0, 2);
          const year = dateStr.slice(2);
          return year + month; // "032025" becomes "202503"
        };

        // Find the latest project based on period.to
        const latest = projects.reduce((a, b) => {
          const timeA = convertToSortable(a.period?.to);
          const timeB = convertToSortable(b.period?.to);

          // If both have no end date, prefer first one
          if (timeA === "000000" && timeB === "000000") return a;

          // If only one has no end date, prefer the one with a date
          if (timeA === "000000") return b;
          if (timeB === "000000") return a;

          // Compare converted dates - latest wins
          return timeB > timeA ? b : a;
        });

        // Cache result
        // localStorage.setItem(
        //   cacheKey,
        //   JSON.stringify({ latest, total: projects.length })
        // );
        // localStorage.setItem(timestampKey, new Date().toISOString());

        // Update state
        this.setState({
          latestProject: latest,
          totalProject: projects.length,
        });
      }
    } catch (error) {
      console.error("Error fetching latest project from Firestore:", error);
    }
  };

  render() {
    const isMobileView = this.state.windowSize <= 1100;

    if (isMobileView) {
      return (
        <div>
          <IntroMobile />
        </div>
      );
    }

    return (
      <div
        style={{
          marginTop: "75px",
        }}
      >
        <Intro />
        <GetToKnowMe />
        <RecentProjects
          latestProject={this.state.latestProject}
          totalProject={this.state.totalProject}
        />

        <LatestBlog />

        <ScrollButton />

        <Footer />
      </div>
    );
  }
}

export default Home;
